import _BaseAPIService from "../_BaseAPIService"

const instance = _BaseAPIService.instance;


const Restrouserstatssummary={
    getUser: async() => {
        try{
            const response = await instance.get("/restrousersstats/summary");
            console.log("Summary Info Response: ",response.data);
            return response.data;
        }
        catch(error){
            console.log("Error fetching Summary Info",error);
            throw error;
        }
    },
};

export default Restrouserstatssummary;
